import { deleteData, getData, postData, putData } from './ApiSettings';

export const createOrder = async (orderData) => {
    try {
        console.log('Creating order with data:', orderData);

        const { 
            items, userId, totalAmount, depositAmount, 
            comments, delivery, userDetails, relayPoint, coupon
        } = orderData;
        
        // First, create the order
        const orderResponse = await postData('/orders', {
            data: {
                user: userId,
                total: totalAmount,
                deposit: depositAmount,
                order_status: 'pending',
                delivery_method: delivery.method,
                delivery_price: delivery.price,
                comments,
                date: new Date(),
                user_details: userDetails,
                relay_point: relayPoint || null,
                coupon
            }
        });

        console.log('Order creation response:', orderResponse);

        if (!orderResponse.data?.data) {
            throw new Error('Failed to create order');
        }

        const order = orderResponse.data.data;
        console.log('Created order:', order);

        // Create order items
        for (const item of items) {
            // Create as many order items as the quantity specifies
            for (let i = 0; i < item.quantity; i++) {
                await postData('/order-items', {
                    data: {
                        order: order.id,
                        product: item.product.id,
                        start_date: item.startDate,
                        end_date: item.endDate,
                        price: item.price, // Individual item price
                    }
                });
            }
        }

        return {
            success: true,
            orderId: order.id,
            documentId: order.documentId
        };

    } catch (error) {
        console.error('Error creating order:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export const getOrderByDocumentId = async (documentId) => {
    try {
        const response = await getData(`/orders?filters[documentId][$eq]=${documentId}&populate[order_items][populate][product]=*&populate=user`);
        if (response.data?.data && response.data.data.length > 0) {
            return response.data.data[0];
        }
        throw new Error('Order not found');
    } catch (error) {
        console.error('Error fetching order:', error);
        throw error;
    }
};

export const getOrder = async (orderId) => {
    try {
        const response = await getData(`/orders/${orderId}?populate=*`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching order:', error);
        return null;
    }
};

export const getUserOrders = async (userId) => {
    try {
        const response = await getData(`/orders?filters[user][id][$eq]=${userId}&populate[order_items][populate][product]=*`);
        // console.log('API Response for orders:', response);
        
        if (!response?.data?.data) {
            console.error('Invalid response format:', response);
            return [];
        }
        
        return response.data.data;
    } catch (error) {
        console.error('Error in getUserOrders:', error);
        throw error;
    }
};

export const cancelOrder = async (orderData, orderItemsData) => {
    try{
        orderItemsData?.map(async (item) => {
            // console.log(item);
            await deleteData(`/order-items/${item.documentId}`);
        });
        await deleteData(`/orders/${orderData.documentId}`);
    }catch(e){
        console.error('Error deleting order: ', e);
        return null;
    }
};

export const updateOrderStatus = async (orderId, status) => {
    try {
        const response = await putData(`/orders/${orderId}`, {
            data: {
                order_status: status
            }
        });
        return response.data.data;
    } catch (error) {
        console.error('Error updating order status:', error);
        return null;
    }
};

export const getOrderTransaction = async (orderId) => {
    try {
        const response = await getData(`/transactions?filters[order][id][$eq]=${orderId}&populate=*`);
        return response.data.data[0];
    } catch (error) {
        console.error('Error fetching order transaction:', error);
        return null;
    }
};

export const updateTransaction = async (transactionId, data) => {
    try {
        const response = await putData(`/transactions/${transactionId}`, {
            data
        });
        return response.data.data;
    } catch (error) {
        console.error('Error updating transaction:', error);
        return null;
    }
};